import request from '@/utils/request'

// 用户登录
export function login(data) {
    return request({
        url: '/user/login/',
        method: 'post',
        data: {
            phone_number: data.phone_number,
            password: data.password
        }
    })
}

// 退出登录
export function logout() {
    // 退出登录主要是清除本地存储的token和用户信息
    return request({
        url: '/user/logout/',
        method: 'post'
    })
}

// 用户注册
export function register(data) {
    return request({
        url: '/user/userInfo/register/',
        method: 'post',
        data: {
            phone_number: data.phone_number,
            password: data.password,
            invitation_code: data.invite_code
        }
    })
}